import { ETypPrevodu } from 'services/specialniSluzby/uePozadavky';

export const typPrevoduSelect = [
    {
        value: ETypPrevodu.BEZZAPLACENI,
        labelcz: 'TYP_PREVODU_BEZZAPLACENI'
    },
    {
        value: ETypPrevodu.PROTIZAPLACENI,
        labelcz: 'TYP_PREVODU_PROTIZAPLACENI'
    },
    {
        value: ETypPrevodu.PROTIABEZZAPL,
        labelcz: 'TYP_PREVODU_PROTIABEZZAPL'
    },
    {
        value: ETypPrevodu.PXVNABEZZAPL,
        labelcz: 'TYP_PREVODU_PXVNABEZZAPL'
    }
];
export const typPrevoduPrevod = [
    {
        value: 'BEZZAPLACENI',
        labelcz: 'TYP_PREVODU_BEZZAPLACENI'
    }
];
